import Cookies from "js-cookie";
import defaultLogo from './Assets/images/loading image 1.png';

export function getDynamicLogo() {
    const kiosk_detailsCookie = Cookies.get('kiosk_details');
    if (kiosk_detailsCookie) {
        try {
            const details = JSON.parse(kiosk_detailsCookie);
            if (details.image) return details.image;
        } catch(e) {}
    }
    return defaultLogo;
}
